import { Flex, Spacer, View } from "@amzn/stencil-react-components/layout";
import { Spinner, SpinnerSize } from "@amzn/stencil-react-components/spinner";
import { getString } from "common/uistringlabels/uiStringUtils";
import React from "react";
import { FC } from "react";

const MyAiToolsLoading: FC = () => {
  return (
    <Flex flexDirection="column">
      <View alignSelf="center">
        <Spacer height="S200" width="S200" />
        <Spinner
          size={SpinnerSize.Medium}
          showText
          loadingText={getString("aiForMe.loadingTools")}
          dataTestId="loading-spinner"
        />
      </View>
    </Flex>
  );
};

export default MyAiToolsLoading;
